module.exports = __webpack_public_path__ + "static/media/calendar-arrow-right.2ccb7e77.svg";